import * as React from 'react';

const Nl16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#9F1330", d: "M1.127 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v1.333h-14z" }), /* @__PURE__ */ React.createElement("path", { fill: "#F1F2F1", d: "M1.127 6.333h14v3.334h-14z" }), /* @__PURE__ */ React.createElement("path", { fill: "#314588", d: "M1.127 9.667h14V11a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2z" }));
Nl16.Size = 16;
Nl16.Title = "Nl";

export { Nl16 as default };
